import { Pipe, PipeTransform } from '@angular/core';
import { FeeChargeRow } from '../../models/fee-config';
import { Charge } from '../../models/configurations';

@Pipe({ name: 'feeOldChargeName', pure: true })
export class FeeOldChargeNamePipe implements PipeTransform {
  transform(oldRow: FeeChargeRow | undefined, charges: Charge[]): string {
    if (!oldRow?.chargeId) return '';
    return charges?.find(charge => charge.id === oldRow.chargeId)?.name ?? '';
  }
}
